const checkDatePlanning = (hour, typeCalcul) => {
    try {
        const date = new Date();
        const hourArray = hour.split(':');
        const hourDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), hourArray[0], hourArray[1]);

        if (typeCalcul === '<') {
            return date < hourDate;
        } else if (typeCalcul === '>') {
            return date > hourDate;
        }
    } catch (error) {
        console.error('checkDatePlanning', error);
    }
};

export default checkDatePlanning;
